<template>
    <a href="" v-on:click.prevent="detailStore.navigateToPage(subPage)"
       class="rounded-lg font-medium text-grey-800 px-3 py-2 hover:bg-grey-200 text-sm whitespace-nowrap tablet:text-center tablet:flex items-center tablet:gap-1 mobile:py-2 mobile:rounded-none mobile:flex-col mobile:px-1"
       :class="{'bg-grey-300': isActive, 'mobile:hidden':hideOnMobile, 'pointer-events-none !text-grey-400 !font-normal': isDisabled}">
        <i class="far text-grey-500 mr-2 tablet:mr-0.5" :class="[{'text-grey-700': isActive, '!text-grey-300': isDisabled}, icon]"></i>
        <span class="tablet:block tablet:text-xs mobile:text-[11px] tablet:leading-tight tablet:font-medium" :class="{'text-black': isActive}">{{title}}
            <span v-if="badge && detailStore.isLoggedIn && hasAccessToCountry" class="badge badge-xs ml-1 tablet:hidden" :class="{'bg-grey-400': isActive}">{{badge}}</span>
        </span>
    </a>
</template>

<script lang="ts">
import {SubPage} from "../types";
import { useDetailStore } from '../store';
import {defineComponent} from 'vue';

export default defineComponent({
    name: "navigation-bar-item",
    props: {
        subPage: {
            required: true,
            type: String as () => SubPage
        },
        title: {
            required: true,
            type: String
        },
        icon: {
            required: true,
            type: String
        },
        badge: {
            required: false,
            type: Number
        },
        isDisabled: {
          type: Boolean,
          required: false  
        },
        hideOnMobile: Boolean
    },
    data() {
        return {
            detailStore: useDetailStore()
        }
    },
    computed: {
        isActive(): boolean {
            return this.detailStore.currentSubPage === this.subPage;
        },
        hasAccessToCountry(): boolean {
            return this.store.countryPermissions[this.detailStore.country] ?? false
        }
    }
});
</script>